import React from 'react';
import styles from './FacultyCard.module.css';

const FacultyCard = ({ img, title, text }) => {
    // Filter out empty strings that might occur from trailing periods
    let list = text.split(".").filter(item => item.trim() !== "");

    return (
        <div className={styles.facultyCard}>
            <div className={styles.imageWrapper}>
                <img src={img} alt={title} className={styles.facultyImage} />
                <div className={styles.imageOverlay}></div>
            </div>
            <div className={styles.facultyContent}>
                <h5 className={styles.title}>{title}</h5>
                <ul className={styles.featureList}>
                    {list.map((item, index) => (
                        <li key={index}>
                            <span className={styles.checkIcon}>✓</span>
                            {item.trim()}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default FacultyCard;